const fetchMenuData = ({
  isFetchedKey,
  apiCall,
  successType,
  loadingType = "SET_MENU_LOADING",
  errorType = "SET_MENU_ERROR"
}) => {
  return () => async (dispatch, getState) => {
    const { mainMenuReducer } = getState();

    if (mainMenuReducer[isFetchedKey]) return;

    dispatch({ type: loadingType, data: true });

    const { data, message, error } = await apiCall();
    
    if (!error) {
      dispatch({ type: successType, data });
    } else {
      dispatch({ type: errorType, data: message });
    }
    dispatch({ type: loadingType, data: false });
  };
};
export default fetchMenuData;  